import { Injectable } from '@angular/core';
import { MapParkGQL, MapPortfolioGQL } from '../../graphql';
import {BehaviorSubject, combineLatest, Observable} from 'rxjs';
import { Geomap } from 'app/models/monitor/geomap.model';
import {distinctUntilChanged, map, switchMap, takeUntil} from 'rxjs/operators';
import { ParkMap } from 'app/models/monitor/parkmap.model';
import { BaseMapModel } from '@wind-log_library/fe-component-library';
import {NavigationDetails} from '../../navigation/navigation.service';

@Injectable()
export class MapDataService {

  constructor(private mapPortfolioGQL: MapPortfolioGQL,
              private mapParkGQL: MapParkGQL) {
  }

  public resizeMap$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public getMapPortfolioData(navigationDetails): Observable<BaseMapModel> {
    return this.mapPortfolioGQL.subscribe({
      variables: {
        portfolioId: navigationDetails.selectedPortfolioId, parkIds: navigationDetails.selectedParksIds}
      }).pipe(
          map(result => Geomap.mapFromPark(result))
        );
  }

  public getMapParkData(parkNameObservable: Observable<string>, navigationDetails: NavigationDetails): Observable<ParkMap> {
    return combineLatest([
      parkNameObservable
    ]).pipe(
      distinctUntilChanged(),
      switchMap(([parkName ]) => {
        return this.mapParkGQL.subscribe({
          variables: {
            name: parkName, turbineIds: navigationDetails.selectedTurbineIds}
        }).pipe(
          map(result => ParkMap.mapFromPark(result.data.parks[0]))
        )}
      ));
  }

}
